// Dashboard number-honesty helpers (2026-08-26).
//
// The redesign's core rule lives here so it is testable and cannot
// drift per-widget: PERCENTAGES ARE EARNED BY VOLUME. "1 of 1 — 100%"
// and "0 of 1 — 0% (red)" are the dashboard equivalent of dividing by
// one; below the threshold we show honest counts and nothing else.
// A dashboard that punishes low volume demotivates exactly the user
// who most needs to keep going.

// Minimum size of the UPSTREAM stage before a stage-to-stage rate is
// worth showing. Below this, rates are noise with a percent sign.
export const RATE_MIN = 20;

/** Is a conversion rate meaningful given the upstream stage count? */
export function rateVisible(prevCount) {
  return Number.isFinite(prevCount) && prevCount >= RATE_MIN;
}

/**
 * Format a current-vs-previous delta for a stat chip.
 * Returns null when there is no previous period to compare against —
 * a delta against nothing is decoration, so the chip doesn't render.
 * Zero IS a real answer ("same as last period"), rendered flat.
 */
export function deltaChip(current, previous) {
  if (!Number.isFinite(current) || !Number.isFinite(previous)) return null;
  const diff = current - previous;
  if (diff > 0) return { dir: 'up', label: `▲ ${diff}` };
  if (diff < 0) return { dir: 'down', label: `▼ ${Math.abs(diff)}` };
  return { dir: 'flat', label: '· 0' };
}
